import "./src/scss/index.css"